export enum monitoringChartFunctions {
    CountWorkflowByUser,
    CountWorkflowByType,
    CountWorkflowSuccessful,
    CountByDayWorkflow
}
